export default __webpack_public_path__ + "static/media/success.d7b979c4.gif";